//
//
//
//

import imgmedicine1 from './images/1.png';
export default {
    data(){
        return{
          medicineDetailData:[
            {
              name:"medicine",
              contain:
                  {
                    title:'标题',
                    p1:"这是第一段",
                    p2:"这是第二段",
                    img1:imgmedicine1,
                    p3:"这是第三段",
                    p4:"这是第四段",
                    img2:imgmedicine1,
                  }
            },
            {
              name:"medicine2",
              contain:
                {
                    title:'标题',
                    p1:"这是第一段2",
                    p2:"这是第二段2",
                    img1:imgmedicine1,
                    p3:"这是第三段2",
                    p4:"这是第四段2",
                    img2:imgmedicine1,
                }
            }
            ]
        }
    },
  mounted(){

    for(let i = 0; i<this.medicineDetailData.length;i++){
            if(this.$route.query.name == this.medicineDetailData[i].name){
              let contain = this.medicineDetailData[i].contain;
                for (let j in contain){
                   if(j.substr(0,1) == 'p'){
                     console.log(contain[j])
                     $(".medicineDetail").append("<p>"+contain[j]+"</p>")
                   }else if(j.substr(0,1) == 't'){
                     $(".medicineDetail").append("<h2>"+contain[j]+"</h2>")
                   }else if(j.substr(0,1) == 'i'){
                     $(".medicineDetail").append("<img src='"+contain[j]+"'>");
                   }
                }
            }
    }
  }
}



// WEBPACK FOOTER //
// ./src/project/medicineAssistant/medicineDetail.vue